<template>
  <div>
    <b-loading :is-full-page="false" :active="loading" />
    <div class="page-wrapper content-report-wrapper">
      <div class="horizontal-section">
        <div class="section_item">
          <div class="form-wrapper" v-for="(section, sIndex) in formCommonSections" :key="sIndex">
            <div class="content-title-wrapper">
              <label class="hierarchy-label">{{ $t(section.label) }}</label>
            </div>
            <div class="items-wrapper">
              <b-field v-for="(field, fIndex) in section.fields" :key="fIndex" :label="$t(field.label)" horizontal>
                <template v-if="field.form === 'input'">
                  <b-input v-model="field.value" :disabled="!canEdit"></b-input>
                </template>
                <template v-else-if="field.form === 'radio'">
                  <b-radio v-for="option in field.list?.options || []" :key="option" v-model="field.value" :native-value="option" :disabled="!canEdit">
                    {{ option }}
                  </b-radio>
                </template>
                <template v-else-if="field.form === 'checkbox'">
                  <b-checkbox v-if="!field.list?.options" v-model="field.value" :disabled="!canEdit">
                    {{ field.label }}
                  </b-checkbox>
                  <div v-else>
                    <b-checkbox v-for="option in field.list.options" :key="option" v-model="field.value" :native-value="option" :disabled="!canEdit">
                      {{ option }}
                    </b-checkbox>
                  </div>
                </template>
                <template v-else-if="field.form === 'select'">
                  <b-select v-model="field.value" placeholder="선택" :disabled="!canEdit">
                    <option v-for="option in field.list.options" :key="option.value" :value="option.value">
                      {{ option.label }}
                    </option>
                  </b-select>
                </template>
              </b-field>
            </div>
          </div>
        </div>

        <div class="section_item">
          <div class="form-wrapper" v-for="(section, sIndex) in formSpecialSections[cancerName]" :key="sIndex">
            <div class="content-title-wrapper">
              <label class="hierarchy-label">{{ $t(section.label) }}</label>
            </div>
            <div class="items-wrapper">
              <b-field v-for="(field, fIndex) in section.fields" :key="fIndex" :label="$t(field.label)" horizontal>
                <template v-if="field.form === 'input'">
                  <b-input v-model="field.value" :disabled="!canEdit"></b-input>
                </template>
                <template v-else-if="field.form === 'radio'">
                  <b-radio v-for="option in field.list?.options || []" :key="option" v-model="field.value" :native-value="option" :disabled="!canEdit">
                    {{ option }}
                  </b-radio>
                </template>
                <template v-else-if="field.form === 'checkbox'">
                  <b-checkbox v-if="!field.list?.options" v-model="field.value" :disabled="!canEdit">
                    {{ field.label }}
                  </b-checkbox>
                  <div v-else>
                    <b-checkbox v-for="option in field.list.options" :key="option" v-model="field.value" :native-value="option" :disabled="!canEdit">
                      {{ option }}
                    </b-checkbox>
                  </div>
                </template>
                <template v-else-if="field.form === 'select'">
                  <b-select v-model="field.value" placeholder="선택" :disabled="!canEdit">
                    <option v-for="option in field.list.options" :key="option.value" :value="option.value">
                      {{ option.label }}
                    </option>
                  </b-select>
                </template>
              </b-field>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div class="panel">
        <div style="width: 100%;">
          <div class="content-title-wrapper">
            <label class="hierarchy-label">{{ $t('final-diagnosis') }}</label>
          </div>
          <div class="form-wrapper">
            <div class="description-editor">
              <cytomine-quill-editor 
                v-if="canEdit"
                v-model="finalDiagnosis"
                :placeholder="$t('enter-pathology-description')"
                :read-only="!canEdit"
              />
              <div 
                v-else 
                class="read-only-text-box"
                v-html="finalDiagnosis || $t('no-diagnosis-content')"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div class="action-buttons" v-if="canEdit">
        <b-button @click="initForm">{{ $t('button-init') }}</b-button>
        <b-button @click="resetForm">{{ $t('button-reset') }}</b-button>
        <b-button type="is-primary" @click="saveForm">{{ $t('button-save') }}</b-button>
      </div>
      <div class="action-buttons" v-else>
        <b-message type="is-info" size="is-small">
          {{ $t('view-only-mode-notice') }} </b-message>
      </div>
    </div>
  </div>
</template>

<script>
import CytomineQuillEditor from '@/components/form/CytomineQuillEditor';
import {get} from '@/utils/store-helpers';
import { reportCommonSectionFormat, reportSpecialSectionFormat } from '../../enums/ReportDataFormat';

export default {
  name: 'project-report-component',
  components: {
    CytomineQuillEditor
  },
  props: {
    caseId: {
      type: Number,
      required: true,
    },
    canEdit: { type: Boolean, default: true },
  },
  data() {
    return {
      loading: false,
      
      // 초기값
      initFormCommonSections: JSON.parse(JSON.stringify(reportCommonSectionFormat)),
      initFormSpecialSections: JSON.parse(JSON.stringify(reportSpecialSectionFormat)),
      initFinalDiagnosis: '',

      // 실제 화면에 뿌리는 값
      formCommonSections: {},
      formSpecialSections: {},
      finalDiagnosis:'',
    };
  },
  watch: {
  },
  computed: {
    project: get('currentProject/project'),
    currentWorklist() {
      return this.$store.getters['worklist/getCurrentWorklist'];
    },

    cancerName() {
      return this.formCommonSections?.[0]?.fields?.[0]?.value || 'not_selected';
    },
    
    dataForSave() {
      return {
        'common': this.formCommonSections,
        'specific': this.formSpecialSections[this.cancerName],
        'final': this.finalDiagnosis,
      };
    },
  },
  methods: {
    initForm() {
      this.$buefy.dialog.confirm({
        title: this.$t('init-form'),
        message: this.$t('init-form-confirmation'),
        confirmText: this.$t('button-confirm'),
        cancelText: this.$t('button-cancel'),
        type: 'is-danger',
        onConfirm: () => {
          this.initData();
        }
      });
    },
    resetForm() {
      this.$buefy.dialog.confirm({
        title: this.$t('reset-form'),
        message: this.$t('reset-form-confirmation'),
        confirmText: this.$t('button-confirm'),
        cancelText: this.$t('button-cancel'),
        type: 'is-warning',
        onConfirm: () => {
          this.resetData();
        }
      });
    },
    async saveForm() {
      this.$buefy.dialog.confirm({
        title: this.$t('save-form'),
        message: this.$t('save-form-confirmation'),
        confirmText: this.$t('button-confirm'),
        cancelText: this.$t('button-cancel'),
        type: 'is-info',
        onConfirm: async () => {
          try {
            this.loading = true;
            await this.project.saveReport(JSON.stringify(this.dataForSave));
            this.saveData();
            this.$notify({
              type: 'success',
              text: this.$t('form-save-success')
            });
          }
          catch (error) {
            console.error('Error saving report:', error);
            this.$notify({
              type: 'error',
              text: this.$t('error-saving-report')
            });
          }
          finally {
            this.loading = false;
          }
        }
      });
    },
    initData() { // 처음 작성하는 경우 및 전체 초기화
      this.formCommonSections = JSON.parse(JSON.stringify(reportCommonSectionFormat));
      this.formSpecialSections = JSON.parse(JSON.stringify(reportSpecialSectionFormat));
      this.finalDiagnosis = '';
    },
    resetData() { // 저장되지 않은 변경사항 버림
      this.formCommonSections = JSON.parse(JSON.stringify(this.initFormCommonSections));
      this.formSpecialSections = JSON.parse(JSON.stringify(this.initFormSpecialSections));
      this.finalDiagnosis = this.initFinalDiagnosis;
    },
    saveData() {
      this.initFormCommonSections = JSON.parse(JSON.stringify(this.formCommonSections));
      this.initFormSpecialSections = JSON.parse(JSON.stringify(this.formSpecialSections));
      this.initFinalDiagnosis = this.finalDiagnosis;
    },
    async loadReport() {
      try {
        const result = await this.project.fetchReport();
        if (result && result['data']) {
          const dataForSaveJson = JSON.parse(result['data']);

          this.initFormCommonSections = dataForSaveJson['common'];
          this.initFormSpecialSections[dataForSaveJson['common'][0].fields[0].value] = dataForSaveJson['specific'];
          this.initFinalDiagnosis = dataForSaveJson['final'];

          this.formCommonSections = JSON.parse(JSON.stringify(this.initFormCommonSections));
          this.formSpecialSections = JSON.parse(JSON.stringify(this.initFormSpecialSections));
          this.finalDiagnosis = this.initFinalDiagnosis;

        }
        this.loading = false;
      } 
      catch (error) {
        if (error.response && error.response.status == 404) {
          console.info('Report not found, keeping initial data.');
          this.initFormCommonSections = JSON.parse(JSON.stringify(reportCommonSectionFormat));
          this.initFormSpecialSections = JSON.parse(JSON.stringify(reportSpecialSectionFormat));
          this.initFinalDiagnosis = '';

          this.formCommonSections = JSON.parse(JSON.stringify(reportCommonSectionFormat));
          this.formSpecialSections = JSON.parse(JSON.stringify(reportSpecialSectionFormat));
          this.finalDiagnosis = '';
        }
        else {
          console.error('Error loading report:', error);
        }
      }
    },

    // calculateStageSubstage(pT, pN, pM) {
    //   let stage = '';
    //   let substage = '';

    //   // Stage 결정
    //   if (pM === 'pM1') {
    //     stage = 'IV';
    //     substage = ''; // Stage IV는 Substage 없음
    //   }
    //   else if (pN === 'pN3' || pT === 'pT4') {
    //     stage = 'III';
    //     // III 세부 단계 결정
    //     if (pT === 'pT1' && pN === 'pN2') substage = 'IIIa';
    //     else if (pT === 'pT2' && pN === 'pN2') substage = 'IIIa';
    //     else if (pT === 'pT3' && (pN === 'pN1' || pN === 'pN2')) substage = 'IIIa';
    //     else if (pT === 'pT4' && (['pN0','pN1','pN2'].includes(pN))) substage = 'IIIb';
    //     else if (['pT1','pT2','pT3','pT4'].includes(pT) && pN === 'pN3') substage = 'IIIc';
    //   }
    //   else if ((pT === 'pT2' && pN === 'pN1') || (pT === 'pT3' && pN === 'pN0')) {
    //     stage = 'II';
    //     if ((pT === 'pT2' && pN === 'pN1') || (pT === 'pT3' && pN === 'pN0')) substage = 'IIa';
    //     else if (pT === 'pT3' && pN === 'pN1') substage = 'IIb';
    //   }
    //   else if (pT === 'pT1' && pN === 'pN0') {
    //     stage = 'I';
    //     substage = 'Ia';
    //   }
    //   else if (pT === 'pT2' && pN === 'pN0') {
    //     stage = 'I';
    //     substage = 'Ib';
    //   }
    //   else {
    //     stage = 'Unknown';
    //     substage = '';
    //   }

    //   return { stage, substage };
    // },

    // updateStageSubstage() {
    //   const tnmSection = this.formCommonSections[4];
    //   const [pT, pN, pM] = tnmSection.fields.slice(0,3).map(f => f.value);

    //   console.log('>>> pT, pN, pM:', pT, pN, pM);

    //   const { stage, substage } = this.calculateStageSubstage(pT, pN, pM);

    //   tnmSection.fields[3].value = stage + (substage ? ` ${substage}` : '');
    // },
  },
  async mounted() {
    this.loading = true;
    this.initData();
    await this.loadReport();
    this.loading = false;
  },
};

</script>

<style scoped lang="scss">
.page-wrapper {
  vertical-align: middle !important;
  height: 100%;
  overflow-y: auto;
}

.content-report-wrapper {
  position: relative;
  padding: 20px;
}

.horizontal-section {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
}

.section_item {
  margin-right: 5rem;
  width: 43%;
  box-sizing: border-box;
}

.content-title-wrapper {
  height: 35px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.panel {
  display: flex;
  flex-direction: row;
  margin-bottom: 1.5rem;
  flex-shrink: 0;
}

.hierarchy-label {
  font-size: 1.3rem;
  color: #4A4847;
}

.form-wrapper {
  padding-bottom: 20px;
}

.items-wrapper {
  padding-left: 25px;
}

.description-editor {
  width: 100%;
  min-height: 300px;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin: 2em 0;
  padding: 0 2.5%;
  flex-shrink: 0;
}
</style>
